import { createTheme } from '@mantine/core';

export const theme = createTheme({
  fontFamily: 'Arial,Helvetica,sans-serif',
  components: {
    Tooltip: {
      styles: (theme: any) => ({
        tooltip: {
          backgroundColor: theme.colors.gray[9], // Dark gray background
          color: theme.white, // White text color
          fontSize: "12px", // Text size
          borderRadius: "0px", // Rounded corners
          border: "2px solid white",
          padding: "4px 8px", // Inner padding
          boxShadow: theme.shadows.md, // Add shadow for better visibility
        },
        arrow: {
          backgroundColor: theme.colors.gray[9], // Match arrow color to tooltip background
        },
      }),
    },
  },
});
